export default {
  header: ['D pol', 'fpp', 'Ø furo'],
  data: [
    ['Nº 1', '64', '1,5'],
    ['Nº 2', '56', '1,8'],
    ['Nº 3', '48', '2,1'],
    ['Nº 4', '40', '2,3'],
    ['Nº 5', '40', '2,6'],
    ['Nº 6', '32', '2,85'],
    ['Nº 8', '32', '3,5'],
    ['Nº 10', '24', '3,9'],
    ['Nº 12', '24', '4,5'],
    ['1/4', '20', '5,2'],
    ['5/16', '18', '6,6'],
    ['3/8', '16', '8'],
    ['7/16', '14', '9,4'],
    ['1/2', '13', '10,8'],
    ['9/16', '12', '12,2'],
    ['5/8 ', '11', '13,5'],
    ['3/4', '10', '16,5'],
    ['7/8 ', '9', '19,5'],
    ['1”', '8', '22,3'],
    ['1” 1/8 ', '7', '25,0'],
    ['1” 1/4', '7', '28,3'],
    ['1” 3/8', '6,0', '30,8'],
    ['1” 1/2', '6', '34'],
    ['1” 3/4', '5', '39,5'],
    ['2”', '4.1/2', '45,0'],
  ],
};
